export enum ComponentId {
  APPLICANT_ADDITIONAL_ARE_OTHER_PEOPLE_INVOLVED = "areOtherPeopleInvolved",
  APPLICANT_ADDITIONAL_PERSONS = "persons",
}
